import React, { Component } from 'react';
// import Loader from 'react-loader-spinner';
import withLoader from '../common/withLoader';
import lod from '../assets/images/Gears-75ms.gif';

class Indicator extends Component {
  render() {
    const { loader } = this.props;
    return (
      <div>
        {loader && (
          <div className="loading">
            <img
              src={lod} style={{ position: 'absolute' }}
              alt="loading..."
              onError={(event) => {
                event.target.src = { lod };
                event.onerror = null;
              }}
            />
            {/* <Loader */}
            {/*  style={{ position: 'absolute' }} */}
            {/*  type="Gears" */}
            {/*  color="#eda340" */}
            {/* /> */}
          </div>
        )}
      </div>
    );
  }
}

export default withLoader(Indicator);
